<template>
  <div class="mpg container">
    <header>
      <img src="../assets/logo.png">
      <div>
        <a href="https://maps.app.goo.gl/yuk1DczVuWakKFBq8" target="_blank">
          <h1>{{ msg }}</h1>
        </a>
        <p class="text-muted mt-3">Located off Los Angeles Ave (Hwy 118) near central Moorpark, our botique shopping plaza is home to several shops, restaurants, and personal services that pursue excellence and add to the delight of our city. Please stop by and explore and enjoy.</p>
      </div>
    </header>

    <main>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <h3 class="float-left">Food &#38 Dining</h3>
          </div>
          <p id="wideline"></p>
        </div>

        <StoreCard
          title="Country Harvest"
          desc="Savory feel good homestyle cooking. Come hungry; leave happy, full, and satisfied."
          img="countryharvest.png"
          url="https://www.countryharvest.restaurant/"
        />
        <StoreCard
          title="Don Cuco"
          desc="Come in and enjoy authentic Mexican cuisine with a commitment to quality. Many dishes are based on old family recipes from the Yucatan Peninsula (Mexico) area."
          img="doncuco.png"
          url="https://doncucorestaurants.com/locations/"
        />
        <StoreCard
          title="Taste of Punjab"
          desc="Savor the rich, buttery, smokey flavors of Northern India tandoori style cooking."
          img="punjab.png"
          url="https://www.tasteofpunjabmoorparkca.com/"
        />
        <StoreCard
          title="Calioh Coffee"
          desc="We are constantly trying to refine our craft while pushing the boundaries of roasting. Our aggressive approach to innovation requires an equal commitment to innovative coffee sourcing."
          img="calioh.png"
          url="https://www.caliohcoffee.com/"
        />
        <StoreCard
          title="Nothin' But Healthy"
          desc="Proudly featuring Herbalife’s world famous Formula 1 Healthy Meal smoothie mix; a complete meal low in sugar and fat."
          img="nothin.png"
          url="https://www.nothinbuthealthy.com/"
        />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row">
            <h3 class="float-left mt-4">Personal Services</h3>
          </div>
          <p id="wideline"></p>
        </div>

        <StoreCard
          title="Functional Beauty"
          desc="We understand that medical aesthetics and skincare is a holistic journey which encompasses both physical treatments, and also attention and care to spiritual and mental beauty."
          img="beauty.png"
          url="https://functionalbeauty.co/"
        />
        <StoreCard
          title="Hair Cuttery"
          desc="We can help you and your family's hair needs. Men, women, and kids haircuts, color,  perms, and eyelash extensions. Walk-ins, welcome."
          img="cuttery.png"
          url="https://website--678339626125207946137-hairsalon.business.site/"
        />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row">
            <h3 class="float-left mt-4">Sports &#38 Fitness</h3>
          </div>
          <p id="wideline"></p>
        </div>

        <StoreCard
          title="Moorpark Karate & Krav Maga"
          desc="Teaching children and adults the confidence, leadership and fitness skills that can only be achieved through martial arts."
          img="karate.png"
          url="https://tsdukarate.com/"
        />
      </div>
    </main>

    <footer class="pt-3 my-5 border-top">
      <span id="footer-mpg">Moorpark Grove Shopping Center</span>
      <a href="https://maps.app.goo.gl/yuk1DczVuWakKFBq8" target="_blank">252 Los Angeles Ave, Moorpark, CA 93021</a>
    </footer>
  </div>
</template>

<script>
import StoreCard from './StoreCard';

export default {
  name: 'MoorparkGrove',
  data () {
    return {
      msg: 'Moorpark Grove Shopping Center'
    }
  },
  components: {
    StoreCard,
  },
}
</script>


<style scoped>
header {
  display: flex;
  margin-bottom: 6em;
}
header img {
  width: 12em;
  margin-right: 3em;
  border-radius: 50%;
}
header a {
  font-family: 'Kaushan Script';
  font-weight: normal;
  font-size: 3em;
  align-self: center;
  color: brown;
}
#footer-mpg {
  font-family: 'Kaushan Script';
  font-size: 1.2em;
  margin-right: 3em;
}
h3 {
  color: brown;
  font-weight: bold;
  margin-left: 1em;
}
#wideline {
  border-bottom: 2px brown solid;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@import url('https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap');
</style>



// WEBPACK FOOTER //
// src/components/MoorparkGrove.vue